import WorkOrderSupplySubContractDetail from '@/models/WorkOrderSupplySubContract/WorkOrderSupplySubContractDetail';

export default class WorkOrderSupplySubContractDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.workOrderSupplySubContractId  = '';
		this.workOrderSupplySubContractMaterialIssueNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.qtyOutstanding = '';
		this.stockVendor = '';
		this.suggestQty = '';
		this.actualQty = '';
		this.uoM = '';
		this.remarksMultiple = '';
		this.actualQtyPicking = '';
		this.purchaseOrderDetailId = '';
		this.qtyPo = '';
		this.partSubcontId  = '';
		this.partSubcontPartNumber = '';
		this.partMappingSubcontId  = '';
		this.partMappingSubcontPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			workOrderSupplySubContractId : '0',
			workOrderSupplySubContractMaterialIssueNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			qtyOutstanding : '0',
			stockVendor : '0',
			suggestQty : '0',
			actualQty : '0',
			uoM : '0',
			remarksMultiple : '0',
			actualQtyPicking : '0',
			purchaseOrderDetailId : '0',
			qtyPo : '0',
			partSubcontId : '0',
			partSubcontPartNumber : '0',
			partMappingSubcontId : '0',
			partMappingSubcontPart : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}